import gsap, { Power3 } from "gsap";
import {
  disableScroll,
  enableScroll,
  passedHTMLObject,
  getHiddenElementHeight,
  getTranslateXY,
} from "./helpers";

class Navbar {
  /**
   * @type {HTMLElement} Language changer toggler HTMLElement
   */
  burgerWrapper = null;

  /**
   * @type {HTMLElement} List with rest of languages HTMLElement
   */ 
  navigation = null;

  /**
   * @type {HTMLElement} Indicates active page element
   */
  indicator = null;

  /**
   * @type {HTMLElement} Actual active menu item
   */
  active = null;

  /**
   * @type {HTMLElement} Active hover menu item
   */
  tempActive = null;

  /**
   * @type {HTMLElement} Element which handles closeing menu on clicking outside
   */
  blurElement = null;

  /**
   * @type {GSAPTimeline} Burger button animation
   */
  burgerTl = null;

  /**
   * @type {GSAPTimeline} Navbar animation
   */
  navbarTl = null;

  /**
   * @type {boolean} Navigation open staus
   */
  opened = false;

  /**
   *
   * @param {String|HTMLElement} header Header wrapper
   * @param {String|HTMLElement} burgerWrapper Burger button wrapper
   * @param {String|HTMLElement} navigation HTMLElement to toggle on burger click
   * @param {String|HTMLElement} blurElement HTMLElement to handle click outside menu
   *
   */
  constructor(header, burgerWrapper, navigation, blurElement = null) {
    this.header = passedHTMLObject(header);
    this.burgerWrapper = passedHTMLObject(burgerWrapper);
    this.navigation = passedHTMLObject(navigation);
    if (blurElement) this.blurElement = passedHTMLObject(blurElement);
  }

  openDropdownsWhenParentActive = () => {
    const { navigation } = this;
    const activeParent = navigation.querySelector(".dropdown.active");
    if (!activeParent) return;
    const dropdownToggler = activeParent.querySelector("button");
    dropdownToggler.click();
  };

  /**
   * Opens dropdown when active page is in dropdown
   * @returns {undefined} When there aren't active dropdowns
   */
  openActiveDropdowns = () => {
    const { navigation, dropdownOpen } = this;
    const activeDropdowns = navigation.querySelectorAll(
      ".dropdown-toggle-button.open"
    );
    if (!activeDropdowns) return;
    activeDropdowns.forEach((dropdownSibling) => {
      dropdownOpen(dropdownSibling.parentElement.nextElementSibling);
    });
  };

  /**
   * Handle close dropdown
   * @param {HTMLElement} dropdown Dropdown element to close
   */
  dropdownClose = (dropdown) => {
    dropdown.classList.remove("open");
    dropdown.setAttribute("aria-hidden", true);

    // const moveHeight = getHiddenElementHeight(dropdown);

    // if (!dropdown.parentElement.classList.contains("dropdown"))
    //   this.changeIndicatorPosition(moveHeight, true);

    if(innerWidth < 992)
    gsap.fromTo(
      dropdown,
      {
        height: getHiddenElementHeight(dropdown),
      },
      {
        height: 0,

        duration: 0.4,
      }
    );
  };

  /**
   * Handle open dropdown
   * @param {HTMLElement} dropdown Dropdown element to open
   */
  dropdownOpen = (dropdown) => {
    dropdown.classList.add("open");
    dropdown.setAttribute("aria-hidden", false);

    const moveHeight = getHiddenElementHeight(dropdown);

    // if (!dropdown.parentElement.classList.contains("dropdown"))
    //   this.changeIndicatorPosition(moveHeight);

    gsap.fromTo(
      dropdown,
      {
        height: 0,
      },
      {
        height: moveHeight,
        duration: 0.4,
        onComplete: () => {
          dropdown.style.height = "auto";
        },
      }
    );
  };

  dropdownToggleEvent = () => {
    const { navigation, dropdownOpen, dropdownClose } = this;

    navigation.addEventListener("click", (e) => {

      if (e.target.classList.contains("dropdown-toggle-button")) {
        e.target.classList.toggle("open");
        const dropdown = e.target.parentElement.nextElementSibling;
        dropdown.classList.contains("open")
          ? dropdownClose(dropdown)
          : dropdownOpen(dropdown);
      }
    });
  };

  changeIndicatorPosition = (value, substract = false) => {
    const actualPosition = getTranslateXY(this.indicator);
    this.indicator.style.transform = `translateY(${
      substract ? actualPosition.y - value : actualPosition.y + value
    }px)`;
  };

  // initializeActiveIndicator = () => {
  //   const { navigation } = this;

  //   const navItemsList = navigation.firstElementChild;

  //   const active = navigation.querySelectorAll(
  //     `#${navItemsList.id}>li.active>a, #${navItemsList.id}>li.active>div>a, #${navItemsList.id}>li.current_page_ancestor>div>a, #${navItemsList.id}>li.current_page_ancestor>a`
  //   );

  //   if (!active.length) return;

  //   const indicator = document.createElement("li");
  //   indicator.classList.add(
  //     "indicator",
  //     "absolute",
  //     "w-[4px]",
  //     "h-[40px]",
  //     "bg-secondary",
  //     "top-0",
  //     "left-0",
  //     "block"
  //   );

  //   const navigationList = this.navigation.firstElementChild;
  //   navigationList.appendChild(indicator);

  //   this.active = {
  //     a: active[0],
  //     li:
  //       active[0].parentElement.tagName.toUpperCase() === "LI"
  //         ? active[0].parentElement
  //         : active[0].parentElement.parentElement,
  //   };

  //   this.tempActive = this.active.li;

  //   const fromTopPosition =
  //     this.active.li.offsetTop +
  //     (this.active.a.offsetHeight - indicator.offsetHeight) / 2;

  //   indicator.style.transform = `translateY(${fromTopPosition}px)`;

  //   this.indicator = indicator;
  // };

  // indicatorSlideEvent = () => {
  //   const { navigation } = this;

  //   const navItems = navigation.querySelectorAll(
  //     `#${navigation.firstElementChild.id}>li`
  //   );

  //   const delayTime = 50;

  //   navItems.forEach((item) => {
  //     let timer;

  //     item.addEventListener("mouseenter", (e) => {
  //       timer = setTimeout(() => {
  //         const aTag = item.querySelector(".nav-link");

  //         const fromTopPosition =
  //           item.offsetTop +
  //           (aTag.offsetHeight - this.indicator.offsetHeight) / 2;

  //         this.indicator.style.transform = `translateY(${fromTopPosition}px)`;

  //         this.tempActive = item;
  //       }, delayTime);
  //     });

  //     item.addEventListener("mouseleave", (e) => {
  //       clearTimeout(timer);
  //     });
  //   });

  //   navigation.firstElementChild.addEventListener("mouseleave", (e) => {
  //     const fromTopPosition =
  //       this.active.li.offsetTop +
  //       (this.active.a.offsetHeight - this.indicator.offsetHeight) / 2;

  //     this.indicator.style.transform = `translateY(${fromTopPosition}px)`;
  //   });
  // };
  /**
   * Initialize burger and navigation animation timelines
   */
  initTimelines = () => {
    const { navigation, burgerWrapper } = this;

    const counter = navigation.querySelector("ul").childElementCount;
    const navItemsList = navigation.firstElementChild;
    const navItems = navigation.querySelectorAll(`#${navItemsList.id}>li`);

    this.navbarTl = gsap.timeline();
    this.navbarTl
      .set(navigation, {
        x: "100%",
        autoAlpha: 0,
      })
      .set(navItems, {
        x: 100,
        autoAlpha: 0,
      });
    this.navbarTl
      .to(
        navigation,

        {
          x: 0,
          autoAlpha: 1,
          duration: counter * 0.1,
        }
      )
      .to(
        navItems,
        {
          x: 0,
          autoAlpha: 1,
          duration: 0.15,
          stagger: {
            each: 0.1,
          },
        },
        `-=${counter * 0.1 - 0.1}`
      );
    this.navbarTl.pause();

    const burgerLines = burgerWrapper.querySelectorAll("span");

    this.burgerTl = gsap.timeline();
    this.burgerTl
      .set(burgerLines[0], {
        y: 0,
        rotate: 0,
      })
      .set(burgerLines[1], {
        scale: 1,
        autoAlpha: 1,
      })
      .set(burgerLines[2], {
        y: 0,
        rotate: 0,
      });

    this.burgerTl
      .to(burgerLines[0], {
        y: 10,
        rotate: 45,
        duration: 0.2,
      })
      .to(
        burgerLines[1],
        {
          scale: 0,
          autoAlpha: 0,
          duration: 0.2,
        },
        "-=0.2"
      )
      .to(
        burgerLines[2],
        {
          y: -10,
          rotate: -45,
          duration: 0.2,
        },
        "-=0.2"
      );
    this.burgerTl.pause();
  };

  addCloseOnEscapeEvent = () => {
    const { burgerWrapper, closeNavigation } = this;
    document.addEventListener("keydown", (e) => {
      if (burgerWrapper.classList.contains("open") && e.key === "Escape") {
        this.opened = false;
        closeNavigation();
      }
    });
  };

  addCloseOnClickOutsideEvent = () => {
    const { burgerWrapper, blurElement, closeNavigation } = this;
    if (blurElement) {
      blurElement.addEventListener("click", (e) => {
        if (burgerWrapper.classList.contains("open")) {
          this.opened = false;
          closeNavigation();
        }
      });
    }
  };

  openNavigation = () => {
    const {
      header,
      blurElement,
      burgerWrapper,
      navigation,
      burgerTl,
      navbarTl,
    } = this;

    disableScroll();
    if (blurElement) blurElement.classList.add("visible");
    burgerWrapper.classList.add("open");
    navigation.classList.add("open");
    header.classList.add("open");
    burgerWrapper.setAttribute("aria-pressed", true);
    navigation.setAttribute("aria-hidden", false);
    burgerTl.play();
    navbarTl.play();
  };

  closeNavigation = () => {
    const {
      header,
      blurElement,
      burgerWrapper,
      navigation,
      burgerTl,
      navbarTl,
    } = this;

    enableScroll();
    if (blurElement) blurElement.classList.remove("visible");
    burgerWrapper.classList.remove("open");
    navigation.classList.remove("open");
    header.classList.remove("open");
    burgerWrapper.setAttribute("aria-pressed", false);
    navigation.setAttribute("aria-hidden", true);
    burgerTl.reverse();
    navbarTl.reverse();
  };

  /**
   * Adds hamburger and navbar toggle event
   */
  addToggleEvent = () => {
    const { burgerWrapper, openNavigation, closeNavigation } = this;

    burgerWrapper.addEventListener("click", (e) => {
      this.opened ? closeNavigation() : openNavigation();
      this.opened = !this.opened;
    });
  };

  addClassOnScrollEvent = () => {
    const { header } = this;
    if (window.scrollY > 120) {
      header.classList.add("scrolled-down");
    }
    const headerTl = gsap.timeline();
    const headerShadow = header.querySelector(".header-shadow");
    const navbarWrapper = header.querySelector(".navbar-wrapper");
    const logo = header.querySelector(".logo-wrapper svg");
    if (header.classList.contains("front-page")) {
      headerTl.fromTo(
        headerShadow,
        {
          backgroundImage: `linear-gradient(
          180deg,
          rgba(81, 19, 80, 0.9) 0%,
          rgba(255, 255, 255, 0)
        )`,
        },
        {
          height: innerWidth < 992 ? 80 : 110,
          backgroundImage: `linear-gradient(
          180deg,
          #61195c 0%,
          #61195c
        )`,
          duration: 0.2,
          ease: "power2.inOut",
        }
      );
    } else if (innerWidth > 992) {
      headerTl.to(headerShadow, {
        // height: innerWidth < 1200 ? 80 : 110,
        clipPath:
          "path('M 0 0 C 0 0 0 0 0 260 C 868 260 1751 260 2441 260 C 2447 94 2445 0 2445 0 Z')",
        duration: 0.2,
        top: "-9rem",
        ease: "power2.inOut",
      });
    }

    if (innerWidth > 992) {
      headerTl.to(
        navbarWrapper,
        {
          paddingTop: 10,
          duration: 0.2,
        },
        "-=0.2"
      );

      headerTl.to(
        logo,
        {
          height: 90,
          duration: 0.2,
        },
        "-=0.2"
      );
    }

    if (window.scrollY > 120) {
      headerTl.play();
      header.classList.add("scrolled-down");
    }

    headerTl.pause();
    window.addEventListener("scroll", (e) => {
      if (window.scrollY > 120) {
        headerTl.play();
        header.classList.add("scrolled-down");
      } else {
        headerTl.reverse();
        header.classList.remove("scrolled-down");
      }
    });
  };

  /**
   * Initialize events
   */
  initEvents = () => {
    const {
      addCloseOnEscapeEvent,
      addToggleEvent,
      dropdownToggleEvent,
      openActiveDropdowns,
      addCloseOnClickOutsideEvent,
      // initializeActiveIndicator,
      // indicatorSlideEvent,
      addClassOnScrollEvent,
      openDropdownsWhenParentActive,
    } = this;

    // initializeActiveIndicator();
    addCloseOnEscapeEvent();
    addToggleEvent();
    dropdownToggleEvent();
    openActiveDropdowns();
    addCloseOnClickOutsideEvent();
    openDropdownsWhenParentActive();
    // indicatorSlideEvent();
    addClassOnScrollEvent();
  };

  /**
   * Mount navbar
   */
  mount = () => {
    const { initTimelines, initEvents } = this;
    initTimelines();
    initEvents();
  };
}

export default Navbar;
